import { useEffect, useState, useRef } from "react";
import Layout from "../../components/layout";
import RankingProcess from "./RankingProcess";
import RankedNFTListSection from "./RankedNFTListSection";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { getRankedNFTsCollection } from "../../slices/aIRanking/aIRankingThunks";
import { RankedNFTsCollection } from "../Marketplace/Types";
import { Filters, Loading } from "./Types";
import HeroSection from "./HeroSection";

const AiRankingPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const rankedNFTListRef = useRef<HTMLDivElement>(null);
  const [rankedNFTsCollectionRows, setRankedNFTsCollectionRows] = useState<
    RankedNFTsCollection[] | []
  >([]);
  const [isLoading, setIsLoading] = useState<Loading>({
    rankedNFTsCollection: false,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<Filters>({
    score: "",
    network: "",
    popularity: "",
    price: "",
  });

  useEffect(() => {
    getRankedNFTsCollectionList(
      currentPage,
      10,
      filters?.score,
      filters?.network,
      filters?.popularity,
      filters?.price
    );
  }, [currentPage]);

  const getRankedNFTsCollectionList = (
    page: number = 1,
    limit: number = 10,
    score: number | string = "",
    network: string | number = "",
    popularity: number | string = "",
    price: number | string = ""
  ) => {
    setIsLoading((prev: any) => ({ ...prev, rankedNFTsCollection: true }));
    const networkId = network === "all" ? "" : network;
    dispatch(
      getRankedNFTsCollection({
        page,
        limit,
        score,
        network: networkId,
        popularity,
        price,
      })
    )
      .then((res: any) => {
        console.log("res", res?.payload?.data?.data);
        if (res?.error) {
          throw new Error(res?.payload);
        }
        setTotalPages(res?.payload?.data?.meta?.totalPages);
        const pageSize = 10;
        // Calculate the starting index for the serial number
        const startingIndex = (page - 1) * pageSize;
        const mappedCollectionRows = res?.payload?.data?.data?.map(
          (item: RankedNFTsCollection, index: number) => ({
            id: item?._id,
            sNo: startingIndex + index + 1,
            bannerImage: item?.bannerImage,
            featureImage: item?.featureImage,
            collection: item?.name,
            score: item?.score,
            floorPrice: item?.floorPrice,
            floorChange: item?.floorChange,
            volume: item?.volumes,
            volumeChange: item?.volumeChange,
            items: item?.items,
            owners: item?.owners,
            sales: item?.sales,
            chain: item?.chain,
          })
        );
        setRankedNFTsCollectionRows(mappedCollectionRows);
      })
      .catch((err) => {
        console.log({err})
      })
      .finally(() => {
        setIsLoading((prev: any) => ({ ...prev, rankedNFTsCollection: false }));
      });
  };

  const scrollToRankedNFTList = () => {
    rankedNFTListRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <Layout>
      <HeroSection onCollectionsClick={scrollToRankedNFTList} />
      <RankingProcess />
      <RankedNFTListSection
        ref={rankedNFTListRef}
        currentPage={currentPage}
        getFilteredNFTsCollection={getRankedNFTsCollectionList}
        rankedNFTsCollectionRows={rankedNFTsCollectionRows}
        filters={filters}
        setFilters={setFilters}
        isLoading={isLoading?.rankedNFTsCollection}
        pagination={{
          totalPages,
          currentPage,
          setCurrentPage,
        }}
      />
      {/* <ConservationLeaderboard />
      <CtaSectionAction /> */}
    </Layout>
  );
};

export default AiRankingPage;
